"use client";

import { motion } from "framer-motion";
import { newsConfig } from "@/lib/newsConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons";

export default function NewsBanner() {
  if (!newsConfig.active) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <div className="space-y-4">
        <span className="inline-flex items-center gap-2.5 rounded-full bg-theorie px-3 py-1 text-base font-bold text-white">
          <FontAwesomeIcon icon={faBullhorn} className="text-xs" />
          {newsConfig.title}
        </span>
        <div className="text-gray-800 leading-relaxed space-y-4">
          <p>
            {newsConfig.message}
            {newsConfig.footer && (
              <>
                {" "}
                <span className="font-semibold">{newsConfig.footer}</span>
              </>
            )}
          </p>
        </div>
      </div>
    </motion.div>
  );
}
